/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetContextKindsPathParams = NonNullable<operations['getContextKinds']['parameters']['path']>;

export type GetContextKindsQueryParams = NonNullable<operations['getContextKinds']['parameters']['query']>;

export interface Input extends GetContextKindsPathParams {
  apiVersion?: string;
  query?: GetContextKindsQueryParams;
}

export async function getContextKinds(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/{flagKey}/monitor/contextKinds', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
